import { render, staticRenderFns } from "./PatientDOB.vue?vue&type=template&id=f8b52bba&scoped=true"
import script from "./PatientDOB.vue?vue&type=script&lang=js"
export * from "./PatientDOB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b52bba",
  null
  
)

export default component.exports